import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { formatDate } from "../../../utils/CommonFunctions";
import { httpAdmin } from "../../../Apis/commonApis";
import {
  reverseTransformDataWithKey,
  transformData,
} from "../carePlanConstant";
import { ShowSwal } from "../../../utils/alertSwal";
import { fetchAdministrativeCarePlan } from "../../../redux-toolkit/reducer/clientCarePlanReducer";
import { useDispatch } from "react-redux";

function ContingencyPlanModal({
  open,
  handleCloseAdmModal,
  openAdmModalDetails,
  CareplanAccess,
}) {
  const clientId = openAdmModalDetails?.commonData?.clientId;
  const dispatch = useDispatch();

  const [formValues, setFormValues] = useState({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (openAdmModalDetails?.isEdit && open) {
      const { _id, ...restData } = openAdmModalDetails?.editData;
      const reversedValues = reverseTransformDataWithKey(restData);
      setFormValues((prev) => ({ ...prev, ...reversedValues }));
    }
  }, [openAdmModalDetails]);

  const handleChangeInputValues = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const createOrUpdateData = async () => {
    const transformDataObj = transformData(formValues);
    const finalData = {
      ...openAdmModalDetails?.commonData,
      ...transformDataObj,
    };
    let apiEnd = "createAdministrativeCarePlan";
    if (openAdmModalDetails?.isEdit) {
      const id = openAdmModalDetails?.editData?._id;
      apiEnd = `updateAdministrativeCarePlan/${id}`;
    }
    const res = await httpAdmin(apiEnd, "post", finalData, null);
    if (res.status) {
      dispatch(fetchAdministrativeCarePlan(clientId));
    }
    ShowSwal(res.status, res.message);
    handleCloseAdmModal();
  };

  const handleDelete = async () => {
    const id = openAdmModalDetails?.editData?._id;
    setLoader(true);
    const res = await httpAdmin(
      `deleteAdministrativeCarePlan/${id}`,
      "delete",
      null,
      null
    );
    setLoader(false);
    ShowSwal(res.status, res.message);
    if (res.status) {
      dispatch(fetchAdministrativeCarePlan(clientId));
      handleCloseAdmModal();
    }
  };

  return (
    <Modal
      className="viewModal"
      show={open}
      size="lg"
      onHide={handleCloseAdmModal}
    >
      <div className="predefineTemplate">
        <h3>Contingency Plan</h3>
        <div className="row mt-4 mb-5 align-items-center">
          <div className="col-md-6">
            <input
              title={`Contingency Plan Record`}
              placeholder={`Contingency Plan Record Name`}
              type="text"
              className="form-control"
              name="TemplateName"
              value={formValues.TemplateName || ""}
              onChange={handleChangeInputValues}
            />{" "}
          </div>
          <div className="col-md-6">
            <ul className="menuListTop">
              <li>
                <button
                  className="btn"
                  onClick={createOrUpdateData}
                  disabled={CareplanAccess !== "full"}
                >
                  {openAdmModalDetails?.isEdit ? "Update" : "Save"}
                </button>
                {openAdmModalDetails?.isEdit && (
                  <button
                    disabled={loader || CareplanAccess !== "full"}
                    className="btn"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                )}
              </li>
              <li>
                <button className="btn" onClick={handleCloseAdmModal}>
                  Close
                </button>
              </li>
            </ul>
          </div>
        </div>

        <Modal.Body>
          <div className="row">
            <div className="col-md-12 mb-3">
              <h6>
                Last Update Date:{" "}
                {formatDate(formValues.last_update_date) || "-"}
              </h6>
              <h6>Updated By: {formValues.updated_by || "-"}</h6>
            </div>
            {/* Questions and Answers Dynamic Form  */}

            <>
              <div className="col-md-12">
                <div className="row">
                  <>
                    <h5>Triggers</h5>
                    <label>Trigger factors</label>
                    <div className="d-flex mb-3">
                      <textarea
                        title="Signs to watch out for that may indicate a significant change in health or other circumstances e.g. feeling agitated"
                        placeholder={
                          "Signs to watch out for that may indicate a significant change in health or other circumstances e.g. feeling agitated"
                        }
                        type="text"
                        className="form-control"
                        name="contingencyTriggerFactors"
                        value={formValues.contingencyTriggerFactors || ""}
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    {/* <h5>Contingency plan name</h5>
                          <div className="d-flex mb-3">
                            <input
                              title="When the action evaluation needs to be reviewed."
                              placeholder={"When the action evaluation needs to be reviewed."}
                              type="text"
                              className="form-control"
                              name="contingencyPlanName"
                              value={formValues.contingencyPlanName}
                              onChange={handleChangeInputValues}
                            />
                          </div> */}
                    <label>What should happen</label>
                    <div className="d-flex mb-3">
                      <textarea
                        title="Guidance on specific actions or interventions that may be required or should be avoided in specific situations. This may include circumstances where action needs to be taken if a carer is unable to care for the person. A statement of suggested actions. Usually expressed as: in the event of X do Y."
                        placeholder={
                          "Guidance on specific actions or interventions that may be required or should be avoided in specific situations. This may include circumstances where action needs to be taken if a carer is unable to care for the person. A statement of suggested actions. Usually expressed as: in the event of X do Y."
                        }
                        rows={4}
                        type="text"
                        className="form-control"
                        name="whatShouldHappen"
                        value={formValues.whatShouldHappen || ""}
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <hr />
                    <h5 className="mb-3">Who should be contacted :</h5>

                    <label>Name</label>
                    <div className="d-flex mb-3">
                      <input
                        title="The name of the professional with responsibility for the care of the person."
                        placeholder={
                          "The name of the professional with responsibility for the care of the person."
                        }
                        type="text"
                        className="form-control"
                        name="whoShouldBeContacted-name"
                        value={formValues["whoShouldBeContacted-name"] || ""}
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Role</label>
                    <div className="d-flex mb-3">
                      <textarea
                        title="The role the professional has in relation to the person e.g. GP, physiotherapist, community nurse, social worker, key worker, care home manager, care coordinator, LA hospital liaison person, care home contact, hospital clinician, Independent Mental Capacity Advocate (IMCA) etc"
                        placeholder={
                          "The role the professional has in relation to the person e.g. GP, physiotherapist, community nurse, social worker, key worker, care home manager, care coordinator, LA hospital liaison person, care home contact, hospital clinician, Independent Mental Capacity Advocate (IMCA) etc"
                        }
                        type="text"
                        className="form-control"
                        name="whoShouldBeContacted-role"
                        value={formValues["whoShouldBeContacted-role"] || ""}
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Contact Details</label>
                    <div className="d-flex mb-3">
                      <input
                        title="Contact details of the personal contact (e.g. telephone number, address, email address etc.)"
                        placeholder={
                          "Contact details of the personal contact (e.g. telephone number, address, email address etc.)"
                        }
                        type="text"
                        className="form-control"
                        name="whoShouldBeContacted-contactDetails"
                        value={
                          formValues["whoShouldBeContacted-contactDetails"] ||
                          ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <hr />

                    <h5 className="mb-3">
                      Agreed with person or legitimate representative :
                    </h5>

                    <label>Person or legitimate representative</label>
                    <div className="d-flex mb-3">
                      <input
                        title="Indicates whether the plan was discussed and agreed with the person or legitimate representative"
                        placeholder={
                          "Indicates whether the plan was discussed and agreed with the person or legitimate representative"
                        }
                        type="text"
                        className="form-control"
                        name="agreedWithPersonOrLegitimateRepresentative-personOrLegitimateRepresentative"
                        value={
                          formValues[
                            "agreedWithPersonOrLegitimateRepresentative-personOrLegitimateRepresentative"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Person full name</label>
                    <div className="d-flex mb-3">
                      <input
                        title="The full name of the person in text representation."
                        placeholder={
                          "The full name of the person in text representation."
                        }
                        type="text"
                        className="form-control"
                        name="agreedWithPersonOrLegitimateRepresentative-personFullName"
                        value={
                          formValues[
                            "agreedWithPersonOrLegitimateRepresentative-personFullName"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Role</label>
                    <div className="d-flex mb-3">
                      <input
                        title="The role the professional has in relation to the person"
                        placeholder={
                          "The role the professional has in relation to the person"
                        }
                        type="text"
                        className="form-control"
                        name="agreedWithPersonOrLegitimateRepresentative-role"
                        value={
                          formValues[
                            "agreedWithPersonOrLegitimateRepresentative-role"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Date this plan was last updated</label>
                    <div className="d-flex mb-3">
                      <input
                        type="date"
                        className="form-control"
                        name="contingencyDateThisPlanWasLastUpdated"
                        value={
                          formatDate(
                            formValues.contingencyDateThisPlanWasLastUpdated
                          ) || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Planned review date/interval</label>
                    <div className="d-flex mb-3">
                      <input
                        type="date"
                        className="form-control"
                        name="contigencyPlannedReviewDate"
                        value={
                          formatDate(formValues.contigencyPlannedReviewDate) ||
                          ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <h5 className="mb-3">Responsibility for review :</h5>

                    <label>Name</label>
                    <div className="d-flex mb-3">
                      <input
                        title="The name of the professional with responsibility for the care of the person."
                        placeholder={
                          "The name of the professional with responsibility for the care of the person."
                        }
                        type="text"
                        className="form-control"
                        name="contigencyResponsibilityForReview-name"
                        value={
                          formValues[
                            "contigencyResponsibilityForReview-name"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Role</label>
                    <div className="d-flex mb-3">
                      <textarea
                        title="The role the professional has in relation to the person e.g. GP, physiotherapist, community nurse, social worker, key worker, care home manager, care coordinator, LA hospital liaison person, care home contact, hospital clinician, Independent Mental Capacity Advocate (IMCA) etc"
                        placeholder={
                          "The role the professional has in relation to the person e.g. GP, physiotherapist, community nurse, social worker, key worker, care home manager, care coordinator, LA hospital liaison person, care home contact, hospital clinician, Independent Mental Capacity Advocate (IMCA) etc"
                        }
                        type="text"
                        className="form-control"
                        name="contigencyResponsibilityForReview-role"
                        value={
                          formValues[
                            "contigencyResponsibilityForReview-role"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Contact Details</label>
                    <div className="d-flex mb-3">
                      <input
                        title="Contact details of the professional (e.g. telephone number, email address etc.)."
                        placeholder={
                          "Contact details of the professional (e.g. telephone number, email address etc.)."
                        }
                        type="text"
                        className="form-control"
                        name="contigencyResponsibilityForReview-contactDetails"
                        value={
                          formValues[
                            "contigencyResponsibilityForReview-contactDetails"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <hr />
                    <h5 className="mb-3">Coping strategies :</h5>

                    <label>Coping strategy</label>
                    <div className="d-flex mb-3">
                      <textarea
                        title="The coping strategies are defined as thoughts and behaviours that people use to manage the internal and external demands of situations that are appraised as stressful. This should also include a record of any tools used to carry out the coping strategy."
                        placeholder={
                          "The coping strategies are defined as thoughts and behaviours that people use to manage the internal and external demands of situations that are appraised as stressful. This should also include a record of any tools used to carry out the coping strategy."
                        }
                        type="text"
                        className="form-control"
                        name="copingStrategies-copingStrategy"
                        value={
                          formValues["copingStrategies-copingStrategy"] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Start date</label>
                    <div className="d-flex mb-3">
                      <input
                        type="date"
                        className="form-control"
                        name="copingStrategies-start_date"
                        value={formatDate(
                          formValues["copingStrategies-start_date"] || ""
                        )}
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>End date</label>
                    <div className="d-flex mb-3">
                      <input
                        type="date"
                        className="form-control"
                        name="copingStrategies-end_Date"
                        value={formatDate(
                          formValues["copingStrategies-end_Date"] || ""
                        )}
                        onChange={handleChangeInputValues}
                      />
                    </div>

                    <label>Relapse indicators / early warning signs</label>
                    <div className="d-flex mb-3">
                      <textarea
                        type="text"
                        title="Details of the relapse indicators for the person. These may also be called 'early warning signs'"
                        placeholder="Details of the relapse indicators for the person. These may also be called 'early warning signs'"
                        className="form-control"
                        name="relapseIndicators_earlyWarningSigns"
                        value={
                          formValues.relapseIndicators_earlyWarningSigns || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <hr />
                    <h5>Advance statement</h5>

                    <label>Date</label>
                    <div className="d-flex mb-3">
                      <input
                        type="date"
                        className="form-control"
                        name="advanceStatement-statementDate"
                        value={formatDate(
                          formValues["advanceStatement-statementDate"] || ""
                        )}
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Location</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the advanced statement was made."
                        placeholder="The location where the advanced statement was made."
                        className="form-control"
                        name="advanceStatement-location"
                        value={formValues["advanceStatement-location"] || ""}
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Advance statement</label>
                    <div className="d-flex mb-3">
                      <textarea
                        type="text"
                        title="Does the person have an advance statement."
                        placeholder="Does the person have an advance statement."
                        className="form-control"
                        name="advanceStatement-advanceStatements"
                        value={
                          formValues["advanceStatement-advanceStatements"] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Location of document</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location of where the advanced statement is held."
                        placeholder="The location of where the advanced statement is held."
                        className="form-control"
                        name="advanceStatement-locationOfDocument"
                        value={
                          formValues["advanceStatement-locationOfDocument"] ||
                          ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <hr />
                    <h5>Performing professional : </h5>

                    <label>Name</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The name of the professional."
                        placeholder="The name of the professional."
                        className="form-control"
                        name="advanceStatementPerformingProfessional-name"
                        value={
                          formValues[
                            "advanceStatementPerformingProfessional-name"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Role</label>
                    <div className="d-flex mb-3">
                      <textarea
                        type="text"
                        title="The role the professional has in relation to the person e.g. GP, physiotherapist, community nurse, social worker etc"
                        placeholder="The role the professional has in relation to the person e.g. GP, physiotherapist, community nurse, social worker etc"
                        className="form-control"
                        name="advanceStatementPerformingProfessional-role"
                        value={
                          formValues[
                            "advanceStatementPerformingProfessional-role"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Grade</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The grade of the professional."
                        placeholder="The grade of the professional."
                        className="form-control"
                        name="advanceStatementPerformingProfessional-grade"
                        value={
                          formValues[
                            "advanceStatementPerformingProfessional-grade"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Speciality</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The specialty of the professional e.g. physiotherapy, oncology, mental health etc"
                        placeholder="The specialty of the professional e.g. physiotherapy, oncology, mental health etc"
                        className="form-control"
                        name="advanceStatementPerformingProfessional-speciality"
                        value={
                          formValues[
                            "advanceStatementPerformingProfessional-speciality"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Professional identifier</label>
                    <div className="d-flex mb-3">
                      <textarea
                        type="text"
                        title="Professional identifier for the professional e.g. GMC number, HCPC number etc or the personal identifier used by the local organisation."
                        placeholder="Professional identifier for the professional e.g. GMC number, HCPC number etc or the personal identifier used by the local organisation."
                        className="form-control"
                        name="advanceStatementPerformingProfessional-professionalIdentifire"
                        value={
                          formValues[
                            "advanceStatementPerformingProfessional-professionalIdentifire"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                        rows={4}
                      />
                    </div>
                    <label>Organisation</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The name of the organisation the professional works for"
                        placeholder="The name of the organisation the professional works for"
                        className="form-control"
                        name="advanceStatementPerformingProfessional-organisation"
                        value={
                          formValues[
                            "advanceStatementPerformingProfessional-organisation"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Date Completed</label>
                    <div className="d-flex mb-3">
                      <input
                        type="date"
                        className="form-control"
                        name="advanceStatementPerformingProfessional-dateCompleted"
                        value={formatDate(
                          formValues[
                            "advanceStatementPerformingProfessional-dateCompleted"
                          ] || ""
                        )}
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Contact details</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="Contact details of the professional"
                        placeholder="Contact details of the professional"
                        className="form-control"
                        name="advanceStatementPerformingProfessional-contactDetails"
                        value={
                          formValues[
                            "advanceStatementPerformingProfessional-contactDetails"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <hr />

                    <h5>Person completing record : </h5>
                    <label>Name</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The name of the person completing the record."
                        placeholder="The name of the person completing the record."
                        className="form-control"
                        name="advanceStatementPersonCompletingRecord-name"
                        value={
                          formValues[
                            "advanceStatementPersonCompletingRecord-name"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Role</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The organisational role of the person completing record."
                        placeholder="The organisational role of the person completing record."
                        className="form-control"
                        name="advanceStatementPersonCompletingRecord-role"
                        value={
                          formValues[
                            "advanceStatementPersonCompletingRecord-role"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Grade</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The grade of the person completing the record."
                        placeholder="The grade of the person completing the record."
                        className="form-control"
                        name="advanceStatementPersonCompletingRecord-grade"
                        value={
                          formValues[
                            "advanceStatementPersonCompletingRecord-grade"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Specialty</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The main specialty of the person completing the record."
                        placeholder="The main specialty of the person completing the record."
                        className="form-control"
                        name="advanceStatementPersonCompletingRecord-speciality"
                        value={
                          formValues[
                            "advanceStatementPersonCompletingRecord-speciality"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Organisation</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The organisation the person completing the record works for."
                        placeholder="The organisation the person completing the record works for."
                        className="form-control"
                        name="advanceStatementPersonCompletingRecord-organisation"
                        value={
                          formValues[
                            "advanceStatementPersonCompletingRecord-organisation"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Professional identifier</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="Professional identifier for the person completing the record e.g. GMC number, HCPC number etc, or the personal identifier used by the local organisation."
                        placeholder="Professional identifier for the person completing the record e.g. GMC number, HCPC number etc, or the personal identifier used by the local organisation."
                        className="form-control"
                        name="advanceStatementPersonCompletingRecord-professionalIdentifire"
                        value={
                          formValues[
                            "advanceStatementPersonCompletingRecord-professionalIdentifire"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Date completed</label>
                    <div className="d-flex mb-3">
                      <input
                        type="date"
                        className="form-control"
                        name="advanceStatementPersonCompletingRecord-dateCompleted"
                        value={formatDate(
                          formValues[
                            "advanceStatementPersonCompletingRecord-dateCompleted"
                          ] || ""
                        )}
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Contact details</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        className="form-control"
                        name="advanceStatementPersonCompletingRecord-contactDetails"
                        value={
                          formValues[
                            "advanceStatementPersonCompletingRecord-contactDetails"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                        placeholder="Contact details of the person completing the record."
                        title="Contact details of the person completing the record."
                      />
                    </div>
                    <hr />
                    <label>Anticipatory Medicines Equipment</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="Medicines or equipment available that may be required in specific situations and their location. A statement regarding the availability or location of the anticipatory medicines/equipment. SNOMED CT Tag : - 871021000000106 | Prescription of palliative care anticipatory medication (procedure)"
                        placeholder="Medicines or equipment available that may be required in specific situations and their location. A statement regarding the availability or location of the anticipatory medicines/equipment. SNOMED CT Tag : - 871021000000106 | Prescription of palliative care anticipatory medication (procedure)"
                        className="form-control"
                        name="anticipatoryMedicinesEquipment"
                        value={
                          formValues["anticipatoryMedicinesEquipment"] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Lontigency Location</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyLocation"
                        value={formValues["contigencyLocation"] || ""}
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <hr />
                    <h5>Contigency Performing Professional : </h5>
                    <label>Name</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPerformingProfessional-name"
                        value={
                          formValues["contigencyPerformingProfessional-name"] ||
                          ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Role</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPerformingProfessional-role"
                        value={
                          formValues["contigencyPerformingProfessional-role"] ||
                          ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Grade</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPerformingProfessional-grade"
                        value={
                          formValues[
                            "contigencyPerformingProfessional-grade"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Speciality</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPerformingProfessional-speciality"
                        value={
                          formValues[
                            "contigencyPerformingProfessional-speciality"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>ProfessionalIdentifire</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPerformingProfessional-professionalIdentifire"
                        value={
                          formValues[
                            "contigencyPerformingProfessional-professionalIdentifire"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Organisation</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPerformingProfessional-organisation"
                        value={
                          formValues[
                            "contigencyPerformingProfessional-organisation"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Contact Details</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPerformingProfessional-contactDetails"
                        value={
                          formValues[
                            "contigencyPerformingProfessional-contactDetails"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <hr />
                    {/* contigencyPersonCompletingRecord: {
                                  name: String,
                                  role: String,
                                  grade: String,
                                  speciality: String,
                                  organisation: String,
                                  professionalIdentifire: String,
                                  dateCompleted: Date,
                                  contactDetails: String,
                                }, */}
                    <h5>Contigency Person Completing Record : </h5>
                    <label>name</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPersonCompletingRecord-name"
                        value={
                          formValues["contigencyPersonCompletingRecord-name"] ||
                          ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>role</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPersonCompletingRecord-role"
                        value={
                          formValues["contigencyPersonCompletingRecord-role"] ||
                          ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>grade</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPersonCompletingRecord-grade"
                        value={
                          formValues[
                            "contigencyPersonCompletingRecord-grade"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>speciality</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPersonCompletingRecord-speciality"
                        value={
                          formValues[
                            "contigencyPersonCompletingRecord-speciality"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>organisation</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPersonCompletingRecord-organisation"
                        value={
                          formValues[
                            "contigencyPersonCompletingRecord-organisation"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Professional Identifire</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPersonCompletingRecord-professionalIdentifire"
                        value={
                          formValues[
                            "contigencyPersonCompletingRecord-professionalIdentifire"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>Date Completed</label>
                    <div className="d-flex mb-3">
                      <input
                        type="date"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPersonCompletingRecord-dateCompleted"
                        value={formatDate(
                          formValues[
                            "contigencyPersonCompletingRecord-dateCompleted"
                          ] || ""
                        )}
                        onChange={handleChangeInputValues}
                      />
                    </div>
                    <label>ContactDetails</label>
                    <div className="d-flex mb-3">
                      <input
                        type="text"
                        title="The location where the contingency plan was prepared."
                        placeholder="The location where the contingency plan was prepared."
                        className="form-control"
                        name="contigencyPersonCompletingRecord-contactDetails"
                        value={
                          formValues[
                            "contigencyPersonCompletingRecord-contactDetails"
                          ] || ""
                        }
                        onChange={handleChangeInputValues}
                      />
                    </div>
                  </>
                </div>
              </div>
            </>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
}

export default ContingencyPlanModal;
